import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListNiveauEtudeComponent } from './list-niveauEtude/list-niveauEtude.component';
import { FilterNiveauEtudeByNamePipe } from 'src/app/shared/pipes/filter-niveauEtude-by-name/filter-niveauEtude-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { NiveauEtudeModalDetailComponent } from './modal/niveauEtude-modal-detail/niveauEtude-modal-detail.component';
import { NiveauEtudeModalAjoutComponent } from './modal/niveauEtude-modal-ajout/niveauEtude-modal-ajout.component';

@NgModule({
	declarations: [
		ListNiveauEtudeComponent,
		NiveauEtudeModalDetailComponent,
		NiveauEtudeModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterNiveauEtudeByNamePipe]
})

export class NiveauEtudeModule {}
